<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link
              :to="parcListDefaultRoute"
              class="nav-link nav-link__parc"
              title="Consulter la liste des parcs"
            >
              <i class="ti-view-list"></i>
              <p id="menu-parcs">Mes parcs</p>
            </router-link>
          </li>

          <drop-down
            class="nav-item"
            :title="user.name"
            title-classes="nav-link"
            icon="ti-user"
            v-if="user"
          >
            <router-link
              to="profile-choice"
              class="nav-link nav-link__parc"
              title="Changer de profil"
            >
              <i class="ti-tag"></i>
              <p>Changer de profil</p>
            </router-link>

            <a
              :href="logoutUrl"
              class="nav-link nav-link__parc"
              title="Quitter l'application"
            >
              <i class="ti-shift-right "></i>
              <p>Quitter</p>
            </a>
          </drop-down>
        </ul>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <!-- <a class="navbar-brand"  href="#" style="font-size: .80744rem;">{{routeName}}</a> -->
      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapGetters } from "vuex";
import { env } from "../../env";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters({
      user: "user"
    })
  },
  data() {
    return {
      activeNotifications: false,
      parcListDefaultRoute: { name: "parc-list", query: { size: 10 } },
      logoutUrl: env.logoutUrl
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>

<style lang="scss">
  .nav-mobile-menu {
    padding: 0 !important;
    padding-top: 5px !important;

    &>ul {
      margin-left: 4px !important;
      margin-top: 5px;
    }

    a {
      display: flex;
      align-items: center;
      padding-left: 10px !important;
      margin: 0 !important;

      i {
        font-size: 15px !important;
        margin-right: 4px !important;
      }
    }

    .dropdown-menu {
      a {
        padding: 0 28px !important;
      }

      i {
        display: none;
      }

      p {
        text-transform: capitalize !important;
      }
    }
  }
</style>
